import React from 'react';
import { RecordingMapping } from '../../../../../../../types/rest/mockServiceTypes';
import { Col, Form, Row } from 'react-bootstrap';
import InboundTypeDropdown from './InboundTypeDropdown';
import { MessagingSourceType } from '../../../../../../../types/rest/assetCatalogTypes';

type ItemProps = {
  item: RecordingMapping; // Adjust this type to match the shape of the items you're rendering
  onChange: (item: RecordingMapping) => void;
  /** Optional label for form controls. */
  label?: string;
  disabled?: boolean;
};

const MessagingMapping = ({ item, onChange, label, disabled }: ItemProps) => {
  return (
    <Row>
      <Col md={4}>
        {label && <label>Virtual Inbound</label>}
        <Form.Control
          disabled={disabled}
          value={item.inboundDestination}
          onChange={e => {
            onChange({ ...item, inboundDestination: e.target.value });
          }}
        />
      </Col>

      <Col md={4}>
        {label && <label>Type</label>}
        <InboundTypeDropdown
          disabled={disabled}
          onChange={(type: MessagingSourceType) => {
            onChange({ ...item, originType: type });
          }}
          selectedType={item.originType}
        />
      </Col>

      <Col md={4}>
        {label && <label>Live Outbound</label>}
        <Form.Control
          disabled={disabled}
          value={item.outboundDestination}
          onChange={e => {
            onChange({ ...item, outboundDestination: e.target.value });
          }}
        />
      </Col>
    </Row>
  );
};

export default MessagingMapping;
